import { http, HttpResponse } from 'msw';
import { MAIN_ADDRESS } from 'config';

export const generateUrl = (path) => `${MAIN_ADDRESS}${path}`;

export function registerHandler({ url, method = 'get', defaultData, defaultError, processRequest } = {}) {
    return function handler({ data, dataType, error, delay } = {}) {
        return http[method](url, async (requestObj) => {
            const hasError = error || defaultError;
            if (delay) await new Promise((res) => setTimeout(res, delay));
            if (hasError) return handleError(hasError, requestObj);
            if (processRequest) await processRequest(requestObj);
            return handleResponse({ data, dataType, defaultData }, requestObj);
        });
    };
}

function handleError({ status = 404, statusText = 'defaultStatusText', data = null }, requestObj) {
    return new HttpResponse(JSON.stringify(data), { status, statusText });
}

function handleResponse({ dataType = 'json', data, defaultData }, requestObj) {
    const responseData = data !== undefined ? data : defaultData || null;
    return HttpResponse[dataType](responseData);
}

export async function enableAPIMocking() {
    if (import.meta.env.VITE_MSW !== 'enabled') return;
    const { worker } = await import('./../mocks/browser/serviceWorker');
    return worker.start({ onUnhandledRequest() {} }); //disable warnings for unhandeled requests
}
